import create from 'zustand';
import { normalizeThemePath } from '@/config/themes';

interface ThemeState {
  currentTheme: string | null;
  previewTheme: string | null;
  setCurrentTheme: (theme: string | null) => void;
  setPreviewTheme: (theme: string | null) => void;
}

function readStoredTheme(): string | null {
  try {
    return normalizeThemePath(localStorage.getItem('emailTheme'));
  } catch {
    return null;
  }
}

export const useThemeStore = create<ThemeState>((set) => ({
  currentTheme: readStoredTheme(),
  previewTheme: null,
  setCurrentTheme: (theme) => {
    const normalized = normalizeThemePath(theme);
    if (normalized) {
      localStorage.setItem('emailTheme', normalized);
    } else {
      localStorage.removeItem('emailTheme');
    }
    set({ currentTheme: normalized, previewTheme: null });
  },
  setPreviewTheme: (theme) => set({ previewTheme: normalizeThemePath(theme) }),
}));
